'use strict';

const Backbone = require('backbone/backbone');
const _ = require('underscore/underscore');

require('./Footer.less');

// function getRandomIntInclusive(min, max) {
//     min = Math.ceil(min);
//     max = Math.floor(max);

//     return Math.floor(Math.random() * (max - min + 1)) + min;
// }


module.exports = Backbone.View.extend({

    el: '.Footer',

    events: {
        // 'click .IndexTitle-text': 'onTrackClick'
    },

    image: 2,

    initialize: function () {
        _.bindAll(this, 'onScroll');

        var onScrollThrottled = _.throttle(this.onScroll, 50, { leading: false });
        window.addEventListener('scroll', onScrollThrottled);
    },

    onScroll: function () {
        var self = this;
        var scrolledPercentage = (100 * window.pageYOffset)
            / (document.body.scrollHeight - window.innerHeight);

        if (scrolledPercentage >= 99) {
            this.shown = true;
            // console.log('showDorenko');
            this.$el.addClass('Footer--easterEgg');
        } else {
            // console.log('hideDorenko');
            this.$el.removeClass('Footer--easterEgg');

            if (this.shown) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(function () {
                    self.$('.Footer-dorenkoImg').attr('src', `/static/img/easterEgg/${self.image}.png`);
                    if (self.image >= 15) {
                        self.image = 1;
                    } else {
                        self.image += 1;
                    }
                }, 190);
            }

            this.shown = false;
        }
    }
});


